/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const propertySearchContainer = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const propertySearchTitle = css`
  color: #0b2948;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`

export const propertySearchRow = (theme: Theme) => css`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
  align-items: flex-start;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    flex: 0;
    justify-content: center;
    width: 100%;
    align-items: center;
  }
`

export const propertySearchInputWrapper = css`
  flex: 1;
  min-width: 0;
`

export const propertySearchButtonWrapper = css`
  align-self: flex-start;
  flex-shrink: 0;
`
